import { createStore, combineReducers, applyMiddleware,compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import davronReducer from './davronReducer';
import thunk from 'redux-thunk';
import { ADD_FILE_TO_FORM, UPDATE_FILE, UPDATE_GLOBAL_COUNT, SHIPPING_ADDRESS_FILLED,
	REMOVE_FILE_FROM_FORM, UPDATE_PAGES, DELETE_DOC, SYNC_CONTACT_INFO, SAME_ADDRESS_CHANGE } from '../constants'
import produce from "immer"

const reducers = {
		globals: davronReducer,
		form: formReducer.plugin({
			davron: (state, action) => {
				switch(action.type) {
					case ADD_FILE_TO_FORM:
						let newState;
						if (state.values.hasOwnProperty("fileSection")) {
							newState = state
						} else {
							newState = {
								...state,
								values: {
									...state.values,
									fileSection: {}
								},
								registeredFields: {
									...state.registeredFields,
									fileSection: {}
								}
							}
						}
						
						return {
							...newState,
							values: {
								...newState.values,
								fileSection: {
									...newState.values.fileSection,
									[action.payload.handle]: {
										...newState.values.fileSection[action.payload.handle],
										words: action.payload.words,
										pages: action.payload.pages
									}
								}
							},
							registeredFields: {
								...newState.registeredFields,
								fileSection: {
									...newState.registeredFields.fileSection,
									[action.payload.handle]: {
										...newState.registeredFields.fileSection[action.payload.handle],
										words: action.payload.pages,
										pages: action.payload.pages
									}
								}
							}
						}

					case UPDATE_PAGES:
						return {
							...state,
							values: {
								...state.values,
								fileSection: {
									...state.values.fileSection,
									[action.payload.handle]: {
										...state.values.fileSection[action.payload.handle],
										pages: action.payload.pages
									}
								}
							},
							registeredFields: {
								...state.registeredFields,
								fileSection: {
									...state.registeredFields.fileSection,
									[action.payload.handle]: {
										...state.registeredFields.fileSection[action.payload.handle],
										pages: action.payload.pages
									}
								}
							}
						}

					case UPDATE_FILE:
						return {
							...state,
							values: {
								...state.values,
								[action.payload.dataName]: action.payload.dataValue
							},
							registeredFields: {
								...state.registeredFields,
								[action.payload.dataName]: action.payload.dataValue
							}
						}

					case UPDATE_GLOBAL_COUNT:
						if (action.payload > 2200) {
							return {
								...state,
								values: {
									...state.values,
									totalQty: action.payload,
									translationLevel: "premium"
								},
								registeredFields: {
									...state.registeredFields,
									totalQty: action.payload,
									translationLevel: "premium"
								}
							}
						} else {
							return {
								...state,
								values: {
									...state.values,
									totalQty: action.payload
								},
								registeredFields: {
									...state.registeredFields,
									totalQty: action.payload
								}
							}
						}

					case SHIPPING_ADDRESS_FILLED:
						if (state.values.sameAddress === true && !state.values.addressline1) {
							return {
								...state,
								values: {
									...state.values,
									billingCountry: state.values.shippingCountry,
									addressline1: state.values.shippingaddressline1,
									addressline2: state.values.shippingaddressline2,
									postalcode: state.values.shippingpostalcode,
									city: state.values.shippingcity,
									state: state.values.shippingstate
								},
								registeredFields: {
									...state.registeredFields,
									billingCountry: state.registeredFields.shippingCountry,
									addressline1: state.registeredFields.shippingaddressline1,
									addressline2: state.registeredFields.shippingaddressline2,
									postalcode: state.registeredFields.shippingpostalcode,
									city: state.registeredFields.shippingcity,
									state: state.registeredFields.shippingstate
								}
							}
						} else if (state.values.sameAddress === true) {
							return {
								...state,
								values: {
									...state.values,
									sameAddress: false
								},
								registeredFields: {
									...state.registeredFields,
									sameAddress: false
								}
							}
						}

						return state

					case SAME_ADDRESS_CHANGE:
						if (!state.values.sameAddress) {
							return {
								...state,
								values: {
									...state.values,
									billingCountry: state.values.shippingCountry,
									addressline1: state.values.shippingaddressline1,
									addressline2: state.values.shippingaddressline2,
									postalcode: state.values.shippingpostalcode,
									city: state.values.shippingcity,
									state: state.values.shippingstate
								},
								registeredFields: {
									...state.registeredFields,
									billingCountry: state.registeredFields.shippingCountry,
									addressline1: state.registeredFields.shippingaddressline1,
									addressline2: state.registeredFields.shippingaddressline2,
									postalcode: state.registeredFields.shippingpostalcode,
									city: state.registeredFields.shippingcity,
									state: state.registeredFields.shippingstate
								}
							}
						}

						return state

					case REMOVE_FILE_FROM_FORM:
						let removeState = produce(state, obj => {
							delete obj["values"]["fileSection"][action.payload]
							delete obj["registeredFields"]["fileSection"][action.payload]
						})

						return removeState

					case DELETE_DOC:
						let changedState = produce(state, obj => {
							delete obj["values"]["fileSection"][action.payload]["document"]
						})

						return changedState

					case SYNC_CONTACT_INFO:
						return {
							...state,
							values: {
								...state.values,
								...action.payload
							},
							registeredFields: {
								...state.registeredFields,
								...action.payload
							}
						}

					default:
						return state
				}
			}
		})
	};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducer = combineReducers(reducers);
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store


// WEBPACK FOOTER //
// ./src/reducers/index.js